import React from "react";
import {
  BookOpen,
  GraduationCap,
  Pencil,
  Route,
  Trash2,
  Upload,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import ListItemCardCst from "@components/ListItemCardCst";
import { formatActivityTypeLabel } from "../AddActivity/config/activityTypes";
import { CatalogEntityType, DraftListItem, draftEntityType } from "../types";

const ENTITY_ICON: Record<CatalogEntityType, React.ReactNode> = {
  activity: <GraduationCap size={20} />,
  course: <BookOpen size={20} />,
  path: <Route size={20} />,
};

interface DraftItemProps {
  draft: DraftListItem;
  badgeLabel: string;
  editLabel: string;
  promoteLabel: string;
  deleteLabel: string;
  onEdit: (draft: DraftListItem) => void;
  onPromote: (draft: DraftListItem) => void;
  onDelete: (draft: DraftListItem) => void;
  actionsDisabled?: boolean;
}

const DraftItem: React.FC<DraftItemProps> = ({
  draft,
  badgeLabel,
  editLabel,
  promoteLabel,
  deleteLabel,
  onEdit,
  onPromote,
  onDelete,
  actionsDisabled,
}) => {
  const { t: tActivity } = useTranslation("wizard-activity");
  const type = draftEntityType(draft);
  const wizard = draft.data?.__draft?.wizard;
  const title = wizard?.title || draft.title || `#${draft.id}`;

  const activityType =
    type === "activity"
      ? formatActivityTypeLabel(draft.lo_type, tActivity)
      : type === "course"
        ? wizard?.digited_code || "COURSE"
        : "PATH";

  return (
    <ListItemCardCst
      icon={ENTITY_ICON[type]}
      title={title}
      subtitle={{ id: draft.id, activityType }}
      badges={[{ label: badgeLabel, variant: "warning" }]}
      moreActions={[
        [
          {
            label: editLabel,
            icon: <Pencil size={16} />,
            onClick: () => onEdit(draft),
            disabled: actionsDisabled,
          },
          {
            label: promoteLabel,
            icon: <Upload size={16} />,
            onClick: () => onPromote(draft),
            disabled: actionsDisabled,
          },
          {
            label: deleteLabel,
            icon: <Trash2 size={16} />,
            onClick: () => onDelete(draft),
            disabled: actionsDisabled,
          },
        ],
      ]}
    />
  );
};

export default DraftItem;
